import { App } from "vue";

import {
  Overlay,
  Toast,
  Loading,
  ActionSheet,
  Col,
  Row,
  Dialog,
  Swipe,
  SwipeItem,
  Popup,
  Lazyload,
  Progress,
  NoticeBar,
  Tab,
  Tabs,
  DatetimePicker
} from "vant";

// 引入vant样式
import "vant/es/toast/style";
import "vant/es/loading/style";
import "vant/es/action-sheet/style";
import "vant/es/popup/style";
// import "vant/es/overlay/style";
// import "vant/es/row/style";
// import "vant/es/col/style";
// import "vant/es/dialog/style";
// import "vant/es/swipe/style";
// import "vant/es/swipe-item/style";
// import "vant/es/popup/style";
// import "vant/es/lazyload/style";
// import "vant/es/progress/style";
// import "vant/es/notice-bar/style";
// import "vant/es/tab/style";
// import "vant/es/tabs/style";
// import "vant/es/datetime-picker/style";

export function setupVant(app: App): void {
  app
    .use(Overlay)
    .use(Toast)
    .use(Loading)
    .use(ActionSheet)
    .use(Row)
    .use(Col)
    .use(Dialog)
    .use(Swipe)
    .use(SwipeItem)
    .use(Popup)
    .use(Lazyload)
    .use(Progress)
    .use(NoticeBar)
    .use(Tab)
    .use(Tabs)
    .use(DatetimePicker);

  // 全局挂载Reflect反射对象,以便在vue模板中使用
  app.config.globalProperties.Reflect = Reflect;
}
